export const AUTH_METHODS = {
  PASSWORD: 'password',
  EMAIL: 'email',
  PHONE: 'sms',
  GOOGLE: 'google',
};

export const BUTTON_LABELS = {
  [AUTH_METHODS.PASSWORD]: 'Password',
  [AUTH_METHODS.EMAIL]: 'Email Code',
  [AUTH_METHODS.PHONE]: 'Continue with Phone',
  [AUTH_METHODS.GOOGLE]: 'Continue with Google',
};

export const BUTTON_SUBTITLES = {
  [AUTH_METHODS.PASSWORD]: 'Sign in with your password/passkey',
  [AUTH_METHODS.EMAIL]: 'Get a verification code',
  [AUTH_METHODS.PHONE]: 'Verify with SMS',
  [AUTH_METHODS.GOOGLE]: null,
};

export const BUTTON_ICONS = {
  [AUTH_METHODS.PASSWORD]: 'key',
  [AUTH_METHODS.EMAIL]: 'mail',
  [AUTH_METHODS.PHONE]: 'phone',
  [AUTH_METHODS.GOOGLE]: 'google',
};
